import React, { FC, ReactElement } from 'react'
import styles from './SatributeCard.module.css'
import classnames from 'classnames'

const SatributeCard: FC<{
	emojiClassName?: string
	title: string
	description: string
	icon: string
}> = (props): ReactElement => {
	return (
		<div className={styles.root}>
			<div className={styles.iconContainer}>
				<div
					className={classnames({ [(props.emojiClassName as any)]: !!props.emojiClassName }, styles.emoji)}
				>
					{props?.icon}
				</div>
			</div>
			<div className={styles.detailContainer}>
				<div className={classnames(styles.title, 'text-lg', 'bold')}>{props.title}</div>
				<div className={classnames(styles.description, 'text-xs', 'semibold')}>
					{props.description}
				</div>
			</div>
		</div>
	)
}

export default SatributeCard
